import React, { useContext, useState, useEffect } from 'react';
import styles from './style.module.scss';
import {Grid,Paper, Button} from '@material-ui/core';
import { Context as AuthContext } from '../../context/AuthContext';


const Coupons = () =>{
    const [selectedTab,setSelectedTab] = useState('Personal Details');
    const { state } = useContext(AuthContext);
    const loginData = state.userData;

    useEffect(() => {
    }, []);

    return <div className = {styles.mainContainer}>
        <h5>Coupons</h5>
        <Grid container spacing={3} id = {styles.parentContainer}>
        <Grid item md={2}>
            {/* <Paper className={styles.wrapper} elevation={2}>
            <h6 className="text-left">New Orders</h6>
            <h5 className="text-left">5</h5>
            <div className="d-flex justify-content-end">
                <Button variant="outlined" color="primary" className="p-0">View</Button>
            </div>
            </Paper> */}
        </Grid>
      </Grid>
    </div>
}

export default Coupons;